import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { BrandMark } from "@/components/ui/BrandMark";
import { BLOG_URL, FEEDBACK_URL, ROUTES } from "@/lib/constants";

export function PublicFooter() {
  const { t } = useTranslation();

  const scrollToSection = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="border-t border-border-default bg-surface py-10">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-6 px-6 md:flex-row md:justify-between">
        {/* Logo + tagline */}
        <div className="flex items-center gap-3">
          <BrandMark className="h-7 w-7" />
          <span className="text-sm text-text-secondary">
            {t("home.footerTagline")}
          </span>
        </div>

        {/* Nav links */}
        <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-text-secondary">
          <a href="#" className="hover:text-text-primary transition-colors">
            {t("home.footerAbout")}
          </a>
          <button
            onClick={() => scrollToSection("how-it-works")}
            className="hover:text-text-primary transition-colors"
          >
            {t("home.footerHowItWorks")}
          </button>
          <a href="#" className="hover:text-text-primary transition-colors">
            {t("home.footerEarn")}
          </a>
          <a
            href={BLOG_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-text-primary transition-colors"
          >
            {t("home.footerBlog")}
          </a>
          <Link to="/agents" className="hover:text-text-primary transition-colors">
            {t("home.footerAgents")}
          </Link>
          <a
            href={FEEDBACK_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-text-primary transition-colors"
          >
            {t("nav.feedback")}
          </a>
          <Link to={ROUTES.PRIVACY} className="hover:text-text-primary transition-colors">
            {t("home.footerPrivacy")}
          </Link>
          <Link to={ROUTES.TERMS} className="hover:text-text-primary transition-colors">
            {t("home.footerTerms")}
          </Link>
        </nav>
      </div>
    </footer>
  );
}
